// src/index.ts
import { useCallback, useMemo, useState } from "react";

// src/toastBridge.ts
var TOAST_EVENT = "coremind:toast";
var emitToast = (payload) => {
  if (typeof window === "undefined") return;
  const detail = {
    type: payload.type ?? "info",
    message: payload.message,
    duration: payload.duration
  };
  window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail }));
};
var getToastEventName = () => TOAST_EVENT;

// src/index.ts
var useGridState = (initial) => {
  const [search, setSearch] = useState(initial?.search ?? "");
  const [filters, setFilters] = useState(initial?.filters ?? {});
  const [sort, setSort] = useState(initial?.sort ?? null);
  const [selectedIds, setSelectedIds] = useState([]);
  const query = useMemo(
    () => ({
      limit: initial?.limit,
      cursor: initial?.cursor ?? null,
      search: search || void 0,
      filters: filters && Object.keys(filters).length ? filters : void 0,
      sort
    }),
    [filters, initial?.cursor, initial?.limit, search, sort]
  );
  const clearSelection = useCallback(() => setSelectedIds([]), []);
  const reset = useCallback(() => {
    setSearch(initial?.search ?? "");
    setFilters(initial?.filters ?? {});
    setSort(initial?.sort ?? null);
    setSelectedIds([]);
  }, [initial?.filters, initial?.search, initial?.sort]);
  return {
    query,
    search,
    filters,
    sort,
    selectedIds,
    setSearch,
    setFilters,
    setSort,
    setSelectedIds,
    clearSelection,
    reset
  };
};
export {
  emitToast,
  getToastEventName,
  useGridState
};
